import { render, staticRenderFns } from "./Can.vue?vue&type=template&id=5cb59443&"
import script from "./Can.vue?vue&type=script&lang=js&"
export * from "./Can.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports